// src/components/store/sections/hero-banner/HeroV93BentoshowcaseOceanCyan.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV93BentoshowcaseOceanCyan(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={93}
      archKey="bento_showcase"
      archLabel="Bento Multi-Tile Hero"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      {...props}
    />
  );
}
